module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2318686.b622e0cf.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2318686.pdf
// module id = 834
// module chunks = 0